import { navigate, type PageProps } from 'gatsby';
import React, { useEffect } from 'react';

import * as ROUTES from '@constants/routes';

import BloodProducts from '@views/Records/Legal/BloodProducts';
import HeroicMeasures from '@views/Records/Legal/HeroicMeasures';
import LivingWill from '@views/Records/Legal/LivingWill';
import OrganDonation from '@views/Records/Legal/OrganDonation';

enum LegalDrilldownTypeParam {
  BloodProducts = 'blood-products',
  HeroicMeasures = 'heroic-measures',
  LivingWill = 'living-will',
  OrganDonation = 'organ-donation',
}

function LegalDrilldownPage({ params }: PageProps) {
  const type = params.type;
  useEffect(() => {
    if (
      !type ||
      !Object.values<string>(LegalDrilldownTypeParam).includes(type)
    ) {
      navigate(ROUTES.DASHBOARD);
    }
  }, [type]);

  switch (type) {
    case LegalDrilldownTypeParam.BloodProducts:
      return <BloodProducts {...params} />;
    case LegalDrilldownTypeParam.HeroicMeasures:
      return <HeroicMeasures {...params} />;
    case LegalDrilldownTypeParam.LivingWill:
      return <LivingWill {...params} />;
    case LegalDrilldownTypeParam.OrganDonation:
      return <OrganDonation {...params} />;
    default:
      return null;
  }
}

export default LegalDrilldownPage;
